export const QuarryProfileConsts = {
  TAB_KEY: "materialDetails",
  TAB_LABEL: "Material Details",
};
